var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-top":"20px"}},[_c('van-loading',{attrs:{"vertical":"","color":"#1989fa"},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('van-icon',{attrs:{"name":"star-o","size":"30"}})]},proxy:true}])},[_vm._v(" 加载中... ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }